export const CJEVENT_ID_COOKIE = 'cjevent'
export const CAPITAL_ONE_EXCLUSIVE_EVENT_TAG = 'capital one exclusive events'

export const CAPITAL_ONE_EXCLUSIVE_SEGMENTS = {
    all: '',
    sports: 'sports',
    dining: 'dining',
    entertainment: 'music,arts & theatre,entertainment'
}

export const CONFIG_ERRORS = {
    AFFILIATE_ID_REQUIRED: {
        key: 'affiliateId',
        message: 'An Affiliate ID configuration is required.'
    },
    CHECKOUT: {
        EMAIL_CAPTURE_MULTI_STEP_DEPENDENCY: {
            key: 'hasEmailCaptureCheckbox',
            message: 'hasEmailCaptureCheckbox requires hasMultiStepCheckout to be true'
        }
    },
    LOGOS: {
        STATIC_IMAGE_PATH_REQUIRED: {
            key: 'logos.{desktop|mobile}.staticImagePath',
            message: 'A staticImagePath is required for each logo Object'
        },
        FOOTER_LOGO_FLAGS_MUTUALLY_EXCLUSIVE: {
            key: 'hasCustomFooterLogo and hasPoweredByVividSeats',
            message: 'Footer flags are mutually exclusive, only one may be set to true at a time'
        }
    },
    LOYALTY: {
        INSURANCE_POINTS_EARN_ONLY_DEPENDENCY: {
            key: 'hasInsurance',
            message: 'hasInsurance cannot be true for Loyalty partners with Points redemption'
        },
        POINTS_EARN_ONLY_POINTS_REDEEM_ONLY_DEPENDENCY: {
            key: 'loyalty.isPointsRedeemOnly',
            message: 'loyalty.isPointsEarnOnly and loyalty.isPointsRedeemOnly cannot both be true'
        },
        PROGRAM_NAME_REQUIRED: {
            key: 'loyalty.programName',
            message: 'A loyalty.programName config is required for Loyalty partners.'
        }
    },
    MERCHANDISING_BANNER: {
        DESKTOP_AND_MOBILE_OBJECTS_REQURED: {
            key: 'merchandisingBanner',
            message: 'A merchandisingBanner requires both desktop and mobile properties.'
        },
        STATIC_IMAGE_PATH_REQUIRED: {
            key: 'merchandisingBanner.{desktop|mobile}.staticImagePath',
            message: 'A staticImagePath is required for each merchandisingBanner Object'
        }
    }
}

export const EVENT_STATUS = {
    POSTPONED: 'POSTPONED',
    RESCHEDULED: 'RESCHEDULED',
    SCHEDULED: 'SCHEDULED',
    TBD: 'TBD'
}

export const ORDER_STATUS = {
    CANCELLED: 'CANCELLED',
    CREATED: 'CREATED',
    PENDING: 'PENDING',
    PROCESSED: 'PROCESSED',
    SENT_TO_BUYER: 'SENT_TO_BUYER'
}
